module.exports = __webpack_public_path__ + "img/缠绵.d52fd4c6.jpg";